import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../base/base.component';
import { PageHeaderComponent } from '../../../core/labels/page-header.component';
import { ExpandPanelComponent } from '../../../core/panels/expand-panel.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { TableComponent } from '../../../core/table/table.component';
import { Interaction } from '../../../../models/api/view/claim/details/accommodations/interactions';
import { ClaimKey } from '../../../../models/api/core/claim-key';
import { getExpandSubject } from '../../../../functions/get-expand-subject';

@Component({
  selector: 'app-interactions',
  imports: [
    PageHeaderComponent,
    TableComponent,
    ColumnComponent,
    ExpandPanelComponent,
  ],
  template: `
    <app-page-header label="Interaction Activity" />

    <app-table
      [dataSource]="interactions"
      [pageSize]="5"
      [scrollable]="false"
      [expandable]="false"
      dataKey="interactionDate"
      recordLabel="interaction"
      recordLabelPlural="records found"
      emptyMessage="Interactions will display here."
      [expandable]="true"
      [sortField]="'interactionDate'"
      [sortOrder]="-1"
      [globalFilterFields]="['interactionDate', 'discussionSummary']"
      #interactionTable
    >
      <app-column name="interactionDate" label="Date" format="d" />
      <app-column name="discussionSummary" [fullRow]="true">
        <ng-template let-data>
          <div class="tw-pb-4">
            <app-expand-panel
              collapseHeight="128px"
              [expanded]="interactionTable.expanded"
              [label]="
                getExpandSubject(data.interactionDate) || 'Interaction'
              "
            >
              <div class="tw-flex tw-gap-8">
                <div class="tw-text-wrap tw-leading-6">
                  {{ data.discussionSummary }}
                </div>
              </div>
            </app-expand-panel>
          </div>
        </ng-template>
      </app-column>
    </app-table>
  `,
  styles: `
    .wordWrap {
      word-wrap: normal;
    }
  `,
})
export class InteractionsComponent extends BaseComponent implements OnInit {
  claim = this.view.currentClaim();
  interactions: Interaction[] = [];

  protected getExpandSubject = getExpandSubject;

  async ngOnInit(): Promise<void> {
    const claimKey: ClaimKey = {
      recordId: this.claim.recordId,
      recordSource: this.claim.recordSource,
    };
    this.interactions = await this.api.interactions.get(claimKey);
    this.interactions = this.interactions.map((interaction) => ({
      ...interaction,
      interactionDate:
        typeof interaction.interactionDate === 'string'
          ? new Date(interaction.interactionDate)
          : interaction.interactionDate,
    }));
    this.view.hideLoading();
  }
}
